<div class="design-system">
    <!-- NEW DESIGN SYSTEM STARTS HERE -->
  
    <form [formGroup]="testingForm" (ngSubmit)="markAsTouched()">
  
      <!-- INPUT -->
      <div class="d-flex flex-column mb-4">
        <label class="improved-label-text">Input<span class="improved-required-color">*</span></label>
        <mat-form-field appearance="outline" class="improved-input ">
          <input matInput placeholder="Enter a value" formControlName="testing">
        </mat-form-field>
        <div class="">
          <mat-error class="w-100 improved-error-message" *ngIf="hasError(testingForm, 'testing', 'required')">
            Testing is required
          </mat-error>
        </div>
      </div>
  
      <!-- TEXTAREA -->
      <div class="d-flex flex-column mb-4">
        <label class="improved-label-text">Textarea<span class="improved-required-color">*</span></label>
        <mat-form-field appearance="outline" class="improved-textarea">
          <textarea matInput placeholder="Enter a message" rows="4" formControlName="testing"></textarea>
        </mat-form-field>
        <div class="">
          <mat-error class="w-100 improved-error-message" *ngIf="hasError(testingForm, 'testing', 'required')">
            Testing is required
          </mat-error>
        </div>
      </div>
  
      <!-- CHECKBOX -->
      <div class="improved-checkbox mb-4">
        <mat-checkbox class="" formControlName="">Enabled</mat-checkbox>
      </div>
  
      <!-- RADIO BUTTON -->
      <div class="improved-radio-group d-flex justify-content-between mb-4">
        <div class="d-flex flex-column">
          <div class="m-0">
            <mat-radio-group formControlName="natureOfBusiness">
              <mat-radio-button [value]="1">Manufacturing</mat-radio-button>
              <mat-radio-button [value]="2">Engineering</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
  
  
      <!-- FOR MODALS -->
  
      <!-- CANCEL BUTTON -->
      <button type="button" class="btn btn-outline-secondary improved-cancel-btn me-3">Cancel</button>
      <!-- SUBMIT BUTTON -->
      <button class="btn btn-primary improved-submit-btn me-3">Submit</button>
      <!-- ADD BUTTON -->
      <button class="btn btn-primary improved-add-btn me-3">Add</button>
      <!-- ADD ROUNDED BUTTON -->
      <button class="btn btn-primary improved-add-rounded-btn me-3">
        <img src="../../assets/images/add-small.svg" alt="">
      </button>
      <!-- outlined -->
      <button class="btn btn-primary improved-update-btn me-3">Update</button>
      <!-- UPDATE BUTTON -->
      <button class="btn btn-primary improved-update-btn me-3">Update</button>
      <!-- UPLOAD BUTTON DASHED -->
      <button class="btn btn-primary improved-upload-dashed-btn me-3">Upload</button>
      <!-- ADD BUTTON NO BACKGROUND -->
      <button class="btn btn-primary improved-add-btn-no-background me-3">Upload</button>
      <!-- Download BUTTON -->
      <button class="btn btn-primary improved-download-btn me-3">Download</button>
      <!-- SAVE BUTTON -->
      <button class="btn btn-primary improved-save-btn me-3">Save</button>
      <!-- DELETE BUTTON -->
      <button class="btn btn-danger improved-delete-btn me-3">Delete</button>
      <!-- APPLY BUTTON -->
      <button type="button" class="btn btn-outline-secondary improved-apply-btn me-3">Apply</button>
      <!-- RESET BUTTON -->
      <button type="button" class="btn btn-outline-secondary improved-reset-btn me-3">Reset</button>
      <!-- DARK BLUE BUTTON -->
      <button type="button" class="btn btn-outline-secondary improved-dark-blue-btn me-2">View Draft</button>
      <!-- BLUE BUTTON -->
      <button type="button" class="btn btn-outline-secondary improved-blue-btn me-2">+ Get Quote</button>
  
      <button class="improved-view-action-btn">View</button>
      <button class="improved-edit-action-btn ms-2">Edit</button>
      <button class="improved-delete-action-btn ms-2">Delete</button>
  
  
      <div class="mt-4 mb-4">
        <mat-form-field appearance="outline" class="improved-input  improved-datepicker">
          <mat-date-range-input [rangePicker]="picker1">
            <input matStartDate formControlName="start" placeholder="Select Date Range">
            <input matEndDate formControlName="end" placeholder="Select Date Range">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-date-range-picker #picker1></mat-date-range-picker>
        </mat-form-field>
      </div>
  
      <!-- VALIDATIONS -->
      <div class="mb-4">
        <mat-error class="w-100 improved-error-message" *ngIf="hasError(testingForm, 'testing', 'required')">
          Testing is required
        </mat-error>
      </div>
  
      <!-- DROPDOWN -->
      <div class="improved-dropdown mb-4">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Dropdown" panelClass="improved-dropdown-options">
            <mat-option *ngFor="let component of components" [value]="component.value">
              {{component.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- BORDERED DROPDOWN -->
      <div class="improved-bordered-dropdown mb-4">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Dropdown" panelClass="improved-dropdown-options">
            <mat-option *ngFor="let component of components" [value]="component.value">
              {{component.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- FILTER DROPDOWN -->
      <div class="improved-filter-dropdown mb-4">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Filter Dropdown" panelClass="improved-dropdown-options">
            <mat-option *ngFor="let component of components" [value]="component.value">
              {{component.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- SEARCH INPUT -->
      <div class="d-flex flex-column mb-4">
        <label class="improved-label-text">Search</label>
        <mat-form-field appearance="outline" class="improved-custom-search">
          <input matInput placeholder="Search here">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
  
      <!-- PAGE TITLE -->
      <h2 class="page-title mb-4">Page Title</h2>
  
      <!-- IMPROVED TABLE -->
      <div class="improved-table">
        <table mat-table [dataSource]="dataSource">
  
          <!-- Position Column -->
          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element"> {{element.position}} </td>
          </ng-container>
  
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
  
          <!-- Weight Column -->
          <ng-container matColumnDef="weight">
            <th mat-header-cell *matHeaderCellDef> Weight </th>
            <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
          </ng-container>
  
          <!-- Symbol Column -->
          <ng-container matColumnDef="symbol">
            <th mat-header-cell *matHeaderCellDef> Symbol </th>
            <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
  
        <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons [ngStyle]="{display: dataSource.data.length > 25 ? 'block' : 'none'}"
          aria-label="Select page of periodic elements" panelClass="custom-pagination"></mat-paginator>
      </div>
  
  
      <!-- HEADINGS -->
      <h2 class="improved-page-label">Heading2</h2>
  
      <!-- modal title -->
       <h4 class="improved-modal-sub-title">Testing</h4>
  
      <!-- title -->
      <label class="improved-label-bold-text">TESTING</label>
  
      <!-- paragraph -->
       <p class="improved-view-modal-paragraph">paragraph</p>
  
  
    </form>
  
    <!-- NEW DESIGN SYSTEM ENDS HERE -->
  </div>
  
  
  <div class="design-system">
    <p style="margin:20px 0px;font-size:40px;font-weight:500">Buttons</p>
    <button mat-flat-button class="primary-button">
      <mat-icon>add</mat-icon>
      Create
    </button>
    <button mat-button class="view-btn">View</button>
    <button mat-flat-button class="edit-button">Edit Details</button>
    <button mat-flat-button class="add-button">Add</button>
    <button mat-flat-button class="cancel-button">Cancel</button>
  
    <p style="margin:20px 0px;font-size:40px;font-weight:500">Heading</p>
    <h1 class="heading-1">Milestone 2 - Admin Portal UI Design</h1>
    <p class="breadcrumb">Project Management / Projects Details / Milestone Details</p>
    <h6 class="description-heading">Milestone Description</h6>
    <p class="description-content">Description Content-Lorem Ipsum</p>
  
    <!-- <p style="margin:20px 0px;font-size:40px;font-weight:500">Form Field</p>
      <mat-form-field>
          <mat-label>Select me</mat-label>
          <mat-select>
              <mat-option value="option">Option</mat-option>
          </mat-select>
          <mat-hint align="end">Here's the dropdown arrow ^</mat-hint>
      </mat-form-field>
      <br /> -->
    <!-- <mat-form-field>
          <mat-label>Choose a date</mat-label>
          <input matInput [matDatepicker]="picker">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
      </mat-form-field> -->
    <!-- <br />
        <mat-form-field>
            <mat-label>Input</mat-label>
            <input matInput>
        </mat-form-field>
        <br />
        <mat-form-field>
            <mat-label>Textarea</mat-label>
            <textarea matInput></textarea>
        </mat-form-field> -->
  
    <div class="custom-select-container-wide wide-dropdown mt-5">
      <mat-form-field appearance="outline">
        <mat-select placeholder="Wide Dropdown">
          <mat-option *ngFor="let component of components" [value]="component.value">
            {{component.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <!-- Select -->
    <div class="custom-select-container-narrow narrow-dropdown mt-3">
      <mat-form-field appearance="outline">
        <mat-select placeholder="Narrow Dropdown">
          <mat-option *ngFor="let component of components" [value]="component.value">
            {{component.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
  
    <!-- form field -->
    <div class="projects-container mt-5">
      <form [formGroup]="projectForm" (ngSubmit)="markAsTouched()">
        <div class="input-container  clr-border-matfield">
          <label>Projects<span class="custom-red-color">*</span></label>
          <div>
            <mat-form-field appearance="outline" class="improved-input ">
              <input matInput placeholder="Enter a value" formControlName="default">
            </mat-form-field>
          </div>
        </div>
  
        <div class="projects-container mt-3">
          <label>Projects<span class="custom-red-color">*</span></label>
          <div>
            <mat-form-field appearance="outline" class="active-input">
              <input matInput placeholder="Disable input" formControlName="disabled">
            </mat-form-field>
          </div>
        </div>
  
  
        <div class="input-container mt-3">
          <label>Projects<span class="custom-red-color">*</span></label>
          <div>
            <mat-form-field appearance="outline" class="error-input">
              <input matInput placeholder="Please Enter a value" formControlName="error">
              <mat-error *ngIf="projectForm.get('error')?.touched">
                Please Enter a value
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  
    <div class="date-range-picker mt-5">
      <mat-form-field appearance="outline">
        <mat-date-range-input [rangePicker]="picker1">
          <input matStartDate formControlName="start" placeholder="Select Date Range">
          <input matEndDate formControlName="end" placeholder="Select Date Range">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-date-range-picker #picker1></mat-date-range-picker>
      </mat-form-field>
    </div>
  
    <div class="date-range-picker mt-5">
      <mat-form-field appearance="outline" floatLabel="auto">
        <input matInput [matDatepicker]="picker2" placeholder="Choose a date">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2 startView="year" [startAt]="startDate"></mat-datepicker>
      </mat-form-field>
    </div>
  
    <div class="date-range-picker mt-5 disabled-date-picker">
      <mat-form-field appearance="outline" floatLabel="auto">
        <input matInput [matDatepicker]="picker3" placeholder="Choose a date" disabled>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker3" disabled></mat-datepicker-toggle>
        <mat-datepicker #picker3 startView="year" [startAt]="startDate"></mat-datepicker>
      </mat-form-field>
    </div>
  
    <section class="example-section mt-5">
      <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox>
    </section>
  
    <!-- <section class="example-section">
          <span class="example-list-section">
            <mat-checkbox class="example-margin"
                          [checked]="allComplete"
                          [color]="task.color"
                          [indeterminate]="someComplete()"
                          (change)="setAll($event.checked)">
              {{task.name}}
            </mat-checkbox>
          </span> -->
    <span class="example-list-section">
      <ul>
        <li *ngFor="let subtask of task.subtasks">
          <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color" (ngModelChange)="updateAllComplete()">
            {{subtask.name}}
          </mat-checkbox>
        </li>
      </ul>
    </span>
  
    <div class="custom-radio-group mt-5">
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
      </mat-radio-group>
    </div>
  
    <div class="custom-radio-group mt-5">
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
        <mat-radio-button value="3" disabled>Option 3 (Disabled)</mat-radio-button> <!-- Disabled radio button -->
      </mat-radio-group>
    </div>
  
    <div class="custom-button mt-5">
      <button mat-button class="styled-button">btn_text</button>
    </div>
  
    <div class="custom-button mt-3">
      <button class="styled-button d-flex align-items-center">
        <img [src]="imagePath + 'small-add.svg'" class="me-2">
        <div>btn_text</div>
      </button>
    </div>
  
    <div class="custom-button mt-3">
      <button class="styled-button d-flex align-items-center">
        &plus;
      </button>
    </div>
  
    <div class="custom-button-add mt-5">
      <button mat-button class="styled-button">btn_text</button>
    </div>
  
    <div class="custom-radio-group mt-5">
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
      </mat-radio-group>
    </div>
  
    <div class="custom-radio-group mt-5">
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
        <mat-radio-button value="3" disabled>Option 3 (Disabled)</mat-radio-button> <!-- Disabled radio button -->
      </mat-radio-group>
    </div>
  
    <div class="custom-button mt-5">
      <button mat-button class="styled-button">btn_text</button>
    </div>
  </div>